"use client";

import React from "react";
import { Star } from "lucide-react";
import { Card, CardContent } from "@/components/ui/card";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { cn } from "@/lib/utils";
const testimonials = [{
  author: "John Derryberry",
  quote: "Thanks for an awesome and professional job on my Audi! Highly recommended. Christian, Felix and Griffin are excellent at their craft and their attention to detail is impressive.",
  position: "4 reviews · 1 photo",
  avatar: "https://sacred-kiwi.10web.cloud/wp-content/uploads/2026/04/John.png?v=wr1tnpm5u5"
}, {
  author: "Hailey Garza",
  quote: "These guys did a great job on my car. I was worried they wouldn't be able to get the water stains out of my seats but they absolutely crushed it. They were extremely quick, efficient, and affordable. I'm planning to use them again when I need a detail. Highly recommend",
  position: "3 reviews · 1 photo",
  avatar: "https://sacred-kiwi.10web.cloud/wp-content/uploads/2026/04/Hailey.png?v=5xl64r8afy2"
}, {
  author: "Terri-Lee Dayal",
  quote: "Found via an IG ad. Really reasonable price for a quality detailing. My car was hardly driven and there were cobwebs and a spider or two. The team did an excellent job in a short space of time. I also appreciated their communication regarding my queries and working with me for an early start. Highly recommend and I shall be using them again.",
  position: "2 reviews",
  avatar: "https://sacred-kiwi.10web.cloud/wp-content/uploads/2026/04/Terri.png?v=5eznxnl3qst"
}, {
  author: "Charlee Underwood",
  quote: "They were very friendly and professional. Communicated very well. They are young but have a lot of experience! Did a great job on my SUV and very affordable!",
  position: "3 reviews",
  avatar: "https://sacred-kiwi.10web.cloud/wp-content/uploads/2026/04/Charlee.png?v=zsnkjglvt1e"
}, {
  author: "Cici Lipset",
  quote: "Very thorough and excellent job. These guys are the real thing meaning they make the car look brand new. I will use them again!!!",
  position: "2 reviews · 2 photos",
  avatar: "https://sacred-kiwi.10web.cloud/wp-content/uploads/2026/04/Cici-lipset.png?v=ezlf3vnihev"
}];
export default function ClientPerspectives() {
  const {
    ref: headerRef,
    isVisible: isHeaderVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  const marqueeItems = [...testimonials, ...testimonials];
  return <section data-section-id="145253" id="client-assurance" className="dark bg-background text-foreground py-24 relative overflow-hidden">
      {}
      <div className="absolute inset-0 opacity-[0.04] pointer-events-none mix-blend-overlay" style={{
      backgroundImage: 'url("data:image/svg+xml,%3Csvg viewBox=%220 0 200 200%22 xmlns=%22http://www.w3.org/2000/svg%22%3E%3Cfilter id=%22noiseFilter%22%3E%3CfeTurbulence type=%22fractalNoise%22 baseFrequency=%220.8%22 numOctaves=%223%22 stitchTiles=%22stitch%22/%3E%3C/filter%3E%3Crect width=%22100%25%22 height=%22100%25%22 filter=%22url(%23noiseFilter)%22/%3E%3C/svg%3E")'
    }} />

      {}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[400px] bg-primary/5 blur-[120px] rounded-full pointer-events-none" />

      <div ref={headerRef} className={cn("container mx-auto px-4 mb-16 text-center relative z-10 transition-all duration-1000 ease-out", isHeaderVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12")}>
        <h2 className="text-4xl md:text-5xl font-bold tracking-tight mb-6 font-default uppercase">Client Reviews</h2>
        <p className="text-muted-foreground mb-6 uppercase tracking-widest text-sm font-medium">All reviews are from our google reviews</p>
        <div className="w-24 h-1 bg-primary mx-auto rounded-full shadow-[0_0_15px_rgba(212,175,55,0.4)]" />
      </div>

      {}
      <style dangerouslySetInnerHTML={{
      __html: `
        @keyframes infinite-scroll {
          0% { transform: translateX(0); }
          100% { transform: translateX(-50%); }
        }
        .animate-infinite-scroll {
          animation: infinite-scroll 45s linear infinite;
        }
        .animate-infinite-scroll:hover {
          animation-play-state: paused;
        }
      `
    }} />

      <div className="relative flex overflow-x-auto md:overflow-hidden w-full z-10 [mask-image:linear-gradient(to_right,transparent,black_10%,black_90%,transparent)] py-8 touch-pan-x">
        <div className="flex w-max md:animate-infinite-scroll">
          {marqueeItems.map((item, i) => <Card key={i} data-index={i} className="w-[280px] md:w-[420px] shrink-0 mx-4 bg-card/60 backdrop-blur-xl border border-white/40 shadow-2xl shadow-black/90 p-0 overflow-hidden transition-transform duration-500 hover:scale-[1.02]">
              <CardContent className="p-10 flex flex-col h-full gap-6">
                <div className="flex gap-1.5">
                  {[...Array(5)].map((_, starIdx) => <Star key={starIdx} className="size-5 fill-primary text-primary drop-shadow-[0_0_8px_rgba(212,175,55,0.4)]" />)}
                </div>
                
                <p className="font-serif italic text-xl text-foreground/90 leading-relaxed flex-grow">
                  "{item.quote}"
                </p>
                
                <div className="pt-6 border-t border-border/30 flex flex-col gap-4">
                  <img src={item.avatar} alt={item.author} className="size-12 rounded-full object-cover border border-primary/20" />
                  <div className="flex flex-col">
                    <span className="font-default font-bold text-primary text-lg tracking-wide">
                      {item.author}
                    </span>
                    <span className="text-xs text-muted-foreground mt-1 font-default font-medium tracking-widest uppercase">
                      {item.position}
                    </span>
                  </div>
                </div>
              </CardContent>
            </Card>)}
        </div>
      </div>
    </section>;
}